import { useSetFilter } from '../../filter';
import { AccountListOrderKey } from '../domain';

export const useSetAccountListOrder = () => {
  return useSetFilter(AccountListOrderKey, 'accountOrderBy', true);
};
